import type * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  StyledIllustration,
  StyledHeadline,
  StyledBodyCopy,
  StyledButton,
} from './generic-error.styled';

type GenericErrorType = {
  refetch: () => void;
};

export const GenericError: React.FC<GenericErrorType> = ({ refetch }) => (
  <>
    <StyledIllustration aria-hidden="true" />
    <StyledHeadline size="xlarge" sizeConfined="xxlarge">
      <FormattedMessage id="LEBENSLAUF_GENERIC_ERROR_TITLE" />
    </StyledHeadline>
    <StyledBodyCopy>
      <FormattedMessage id="LEBENSLAUF_GENERIC_ERROR_BODY" />
    </StyledBodyCopy>
    <StyledButton onClick={() => refetch()} variant="tertiary">
      <FormattedMessage id="LEBENSLAUF_GENERIC_ERROR_BUTTON" />
    </StyledButton>
  </>
);
